<template>
    <div class="desk-tabs-container">
        <div class="desk-tabs-header">
            <div
                class="tabs-head-item"
                :class="{ active: activeCode === item.code }"
                v-for="item in tabsData.childList"
                v-has="item.auth"
                :key="item.code"
                @click="onChange(item)"
            >
                <div class="tabs-head-item-inner">
                    <div
                        class="heade-left-circle"
                        :class="item.iconClass"
                    ></div>
                    <div class="heade-right-content">
                        <span
                            class="heade-right-label"
                            :class="'bigData-tabs-view-'+item.code"
                            @click.stop="onSubChange(item)"
                            >{{ item.label }}
                            <i class="heade-right-arrow arrow-icon"></i
                        ></span>
                        <span class="heade-right-num"
                            >{{ item.num }}
                            <span class="heade-right-unit">{{
                                item.unit
                            }}</span></span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="desk-tabs-content">
            <slot :tabsCode="activeCode"></slot>
        </div>
        <div class="desk-tabs-footer" v-if="isConfig">
            <i
                class="desk-tabs-footer-btn delete-icon"
                @click="onDelte(tabsData)"
            ></i>
            <i class="desk-tabs-footer-btn move-icon"></i>
        </div>
    </div>
</template>
<script>
import bigDataLog from '@/utils/bigDataLog';
import { mapGetters } from 'vuex';

export default {
    props: {
        tabsData: {
            type: Object,
            default() {
                return {
                    code: '',
                    isRemove: false,
                    childList: []
                };
            }
        },
        isConfig: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            activeCode: ''
        };
    },
    computed: {
        ...mapGetters([
            'btnPermissions'
        ])
    },
    created() {
        const list = this.tabsData.childList;
        for (const item of list) {
            if (this.btnPermissions.includes(item.auth)) {
                this.activeCode = item.code;
                this.onChange(item);
                break;
            }
        }
    },
    methods: {
        onChange(params) {
            this.activeCode = params.code;
            this.$emit('onChange', params);
            bigDataLog.sendDetailMessageByKey('bigData-tabs-' + params.code);
        },
        onSubChange(params) {
            if (this.activeCode === params.code) {
                this.$emit('onSubChange', params);
                bigDataLog.sendDetailMessageByKey(
                    'bigData-tabs-view-' + params.code
                );
            } else {
                this.activeCode = params.code;
                this.$emit('onChange', params);
                bigDataLog.sendDetailMessageByKey('bigData-tabs-' + params.code);
            }
        },
        onDelte(params) {
            this.$emit('on-delete', params);
        }
    }
};
</script>
<style lang="less" scoped>
/deep/ .el-table__header {
    border-radius: 4px 4px 0px 0px;
    overflow: hidden;
}
.arrow-icon {
    background: url(../img/arrow-right@2x.png) no-repeat;
    background-size: 100%;
}
.desk-tabs {
    &-container {
        // border: 1px solid rgb(235, 115, 115);
    }
    &-header {
        display: flex;

        .tabs-head-item {
            // border: 1px solid rgb(88, 88, 221);
            display: flex;
            width: 223px;
            height: 96px;
            cursor: pointer;
            border-radius: 4px 4px 0px 0px;
            background-color: rgba(255, 255, 255, 0.32);
            &.active {
                background-color: #ffffff;
                .heade-right-arrow {
                    display: inline-block;
                }
                .heade-right-label {
                    color: #2881ff;
                }
            }
            &-inner {
                display: flex;
                justify-content: flex-start;
                width: 176px;
                margin: 22px 31px 0 10px;
            }
            .heade-left-circle {
                display: inline-block;
                width: 76px;
                height: 76px;
            }
            .heade-right {
                &-content {
                    display: inline-block;
                    height: 56px;
                    // border: 1px solid blue;
                }
                &-label {
                    position: relative;
                    display: flex;
                    height: 20px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #4e5969;
                    // color: #2881ff;
                    line-height: 20px;
                }

                &-arrow {
                    position: absolute;
                    width: 6px;
                    height: 10px;
                    top: 5px;
                    right: -17px;
                    color: #2881ff;
                    display: none;
                }

                &-num {
                    display: flex;
                    margin-top: 4px;
                    align-items: flex-end;
                    height: 32px;
                    font-size: 24px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #1d2129;
                    line-height: 32px;
                }
                &-unit {
                    position: relative;
                    top: -4px;
                    height: 20px;
                    margin-left: 5px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #4e5969;
                    line-height: 20px;
                }
            }
            .buy-icon {
                background: url(../img/waitBuy.png) no-repeat;
                background-position: 50% -3px;
                background-size: 100%;
            }
            .bond-icon {
                background: url(../img/waitBond.png) no-repeat;
                background-position: 50% -3px;
                background-size: 100%;
            }
            .stamp-icon {
                background: url(../img/stamp.png) no-repeat;
                background-position: 50% -3px;
                background-size: 100%;
            }
            .quotation-icon {
                background: url(../img/quotation.png) no-repeat;
                background-position: 50% -3px;
                background-size: 100%;
            }

            .sign-icon {
                background: url(../img/sign.png) no-repeat;
                background-position: 50% -3px;
                background-size: 100%;
            }
            .payment-icon {
                background: url(../img/payment.png) no-repeat;
                background-position: 50% -3px;
                background-size: 100%;
            }
        }
    }
    &-content {
        padding: 20px 24px 25px;
        background-color: #ffffff;
        border-radius: 0px 0px 4px 4px;
    }
    &-footer {
        display: flex;
        justify-content: flex-end;
        background-color: #ffffff;
        padding: 0 24px 25px;
        // border: 1px solid red;
        &-btn {
            display: inline-block;
            width: 14px;
            height: 14px;
            margin-right: 22px;
            &:last-child {
                margin-right: 0;
            }

            &:hover {
                opacity: 0.9;
            }
            &:active {
                opacity: 0.6;
            }
        }
        .delete-icon {
            background: url(../img/delete.png) no-repeat;
            background-size: 100%;
            cursor: pointer;
        }
        .move-icon {
            background: url(../img/move-outline.png) no-repeat;
        }
    }
}
</style>
